export interface ModuleStateApiResource {
  module_key: string;
  is_enabled: boolean;
  is_core: boolean;
  is_globally_available?: boolean;
}

export interface ModuleState {
  moduleKey: string;
  isEnabled: boolean;
  isCore: boolean;
  isGloballyAvailable: boolean;
}

export function mapApiResourceToModuleState(resource: ModuleStateApiResource): ModuleState {
  return {
    moduleKey: resource.module_key,
    isEnabled: resource.is_enabled,
    isCore: resource.is_core,
    isGloballyAvailable: resource.is_globally_available !== false,
  };
}
